import { useContext, useMemo } from 'react'
import { NotificationDTO } from '../types/notifications'
import { BrowserContext } from 'context'
import dayjs from 'dayjs'

export const useNotificationTime = (notification: NotificationDTO) => {
  const { isMobile } = useContext(BrowserContext)

  return useMemo(() => {
    const createdOn = new Date(notification.createdOn * 1000)
    const now = new Date()
    //  if the notification was created today
    if (createdOn.getDate() === now.getDate()) {
      const hours = now.getHours() - createdOn.getHours()
      const minutes = now.getMinutes() - createdOn.getMinutes()

      if (hours === 0) {
        if (minutes === 0) {
          return isMobile ? 'now' : 'just now'
        }

        return isMobile ? `${minutes}m` : `${minutes} minutes ago`
      }
      return isMobile ? `${hours}h` : `${hours} hours ago`
    }

    // if the notification was created yesterday
    if (createdOn.getDate() === now.getDate() - 1) {
      return 'Yesterday'
    }

    // if the notification was created before yesterday
    return isMobile
      ? dayjs(createdOn).format('MM/DD/YY')
      : dayjs(createdOn).format('MM/DD/YYYY')
  }, [isMobile, notification.createdOn])
}
